import Tef from './tef'
import { getSessionId } from '../../services'

function organizaTransacoesPendentes(dados) {
    if(!dados) return []
    const transacoes = []
    let item = {}
    for(let i = 0; i < dados.length; i++) {
        const dado = dados[i]
        if(
            dado.TipoCampo === 160 || 
            dado.TipoCampo === 161 || 
            dado.TipoCampo === 163 || 
            dado.TipoCampo === 164 || 
            dado.TipoCampo === 211 || 
            dado.TipoCampo === 1319
        ) {
            item[dado.TipoCampo] = dado.Valor
        }

        if(dado.TipoCampo === 1319) {
            transacoes.push(item)
            item = {}
        }
    }

    return transacoes
}

function filtrarCampos(tipoCampo) {
    switch (tipoCampo) {
        case '121': //comprovante cliente
            return true
        case '122': //comprovante loja
            return true
        case '133': //nsu sitef
            return true
        case '134': //nsu autorizadora
            return true
        case 'numero_parcelas':
            return true
        default:
            return true
    }
}

function organizaDadosTef(dados) {
    if(!dados) return {}
    const dadosFormatados = {}
    for(let i = 0; i < dados.length; i++) {
        const dad = dados[i]
        if(filtrarCampos(String(dad.TipoCampo))) {
            dadosFormatados[String(dad.TipoCampo)] = dad.Valor
        }
    }
    return dadosFormatados
}

function organizaDadosTefReimpressao(dados) {
    if(!dados) return {}
    const dadosFormatados = {}
    for(let i = 0; i < dados.length; i++) {
        const dad = dados[i]
        dadosFormatados[String(dad.TipoCampo)] = dad.Valor
    }
    return dadosFormatados
}

function getInterfaceSitef(manipuladores, config) {
    const servico = new Tef(manipuladores, config)
    let cpf = ''

    async function getState() {
        return servico.getState()
    }

    async function getStatePinPad(sessionId) {
        return servico.getStatePinPad(sessionId)
    }

    async function getSession() {
        return servico.getSession()
    }

    async function createSession() {
        return servico.createSession()
    }

    async function deleteSession() {
        return servico.deleteSession()
    }

    function getSessionId() {
        return servico.getSessionId()
    }

    async function verificaEstadoInicial() {
        let sessionId = null;

        try {
            const sessionAtual = await servico.getSession();

            if (sessionAtual && sessionAtual.sessionId) {
                sessionId = sessionAtual.sessionId;
            }
        } catch (e) {
            sessionId = null;
        }

        if (!sessionId) {
            const novaSession = await servico.createSession();

            if (novaSession.serviceStatus !== 0) {
                throw novaSession.serviceMessage || "Erro ao criar sessão CliSiTef."
            }

            sessionId = novaSession.sessionId;
        }

        servico.setSessionId(sessionId);

        /////////////////////

        const state = await servico.getState();

        if (state.serviceStatus !== 0) {
            throw 'AgenteCliSiTef indisponível'
        }

        switch (state.serviceState) {
            case 0: {
                throw 'Agente não inicializado.'
                break;
            }
            case 1: {
                break;
            }
            case 2: {
                const data = await servico.chamarContinueTransactionCompatibilidade()
                if(!data.status) throw data.message
                break;
            }
            case 3: {
                const data = await servico.chamarContinueTransactionCompatibilidade()
                if(!data.status) throw data.message
                break;
            }
            case 4: {
                break;
            }
            default: {
                throw 'TEF erro não catalogado'
                break;
            }
        }

    }

    function transacaoCredito({valor, cupomFiscal, dataFiscal, horaFiscal, hasCallFinishTransaction}) {
        return new Promise((resolve) => {
            const config = {
                cupomFiscal: cupomFiscal,
                dataFiscal: dataFiscal,
                horaFiscal: horaFiscal,
                trnAdditionalParameters: `{TransacoesHabilitadas=26}${cpf ? `;{CPFColetado=${cpf}}` : ``}`,
                handleTermina: (status, data, message) => {
                    resolve({
                        status, data: organizaDadosTef(data), message
                    })
                },
                hasCallFinishTransaction: hasCallFinishTransaction
            }
            servico.startTransation(3, valor, config)
        })
    }

    function transacaoParceladoEstabelecimento({valor, cupomFiscal, dataFiscal, horaFiscal, hasCallFinishTransaction}) {
        return new Promise((resolve) => {
            const config = {
                cupomFiscal: cupomFiscal,
                dataFiscal: dataFiscal,
                horaFiscal: horaFiscal,
                trnAdditionalParameters: `{TransacoesHabilitadas=27}${cpf ? `;{CPFColetado=${cpf}}` : ``}`,
                handleTermina: (status, data, message) => {
                    resolve({
                        status, data: organizaDadosTef(data), message
                    })
                },
                hasCallFinishTransaction: hasCallFinishTransaction
            }
            servico.startTransation(3, valor, config)
        })
    }

    function transacaoParceladoAdministradora({valor, cupomFiscal, dataFiscal, horaFiscal, hasCallFinishTransaction}) {
        return new Promise((resolve) => {
            const config = {
                cupomFiscal: cupomFiscal,
                dataFiscal: dataFiscal,
                horaFiscal: horaFiscal,
                trnAdditionalParameters: `{TransacoesHabilitadas=28}${cpf ? `;{CPFColetado=${cpf}}` : ``}`,
                handleTermina: (status, data, message) => {
                    resolve({
                        status, data: organizaDadosTef(data), message
                    })
                },
                hasCallFinishTransaction: hasCallFinishTransaction
            }
            servico.startTransation(3, valor, config)
        })
    }

    function transacaoDebito({valor, cupomFiscal, dataFiscal, horaFiscal, hasCallFinishTransaction}) {
        return new Promise((resolve) => {
            const config = {
                cupomFiscal: cupomFiscal,
                dataFiscal: dataFiscal,
                horaFiscal: horaFiscal,
                trnAdditionalParameters: `{TransacoesHabilitadas=16}${cpf ? `;{CPFColetado=${cpf}}` : ``}`,
                handleTermina: (status, data, message) => {
                    resolve({
                        status, data: organizaDadosTef(data), message
                    })
                },
                hasCallFinishTransaction: hasCallFinishTransaction
            }
            servico.startTransation(2, valor, config)
        })
    }

    function transacaoPix({valor, cupomFiscal, dataFiscal, horaFiscal, hasCallFinishTransaction}) {
        return new Promise((resolve) => {
            const config = {
                cupomFiscal: cupomFiscal,
                dataFiscal: dataFiscal,
                horaFiscal: horaFiscal,
                trnAdditionalParameters: `{TransacoesAdicionaisHabilitadas=7};{DevolveStringQRCode=1}${cpf ? `;{CPFColetado=${cpf}}` : ``}`,
                handleTermina: (status, data, message) => {
                    resolve({
                        status, data: organizaDadosTef(data), message
                    })
                },
                hasCallFinishTransaction: hasCallFinishTransaction
            }
            servico.startTransation(122, valor, config)
        })
    }

    function getTransacoesPendentes({ cupomFiscal, dataFiscal, horaFiscal, confirma }) {
        return new Promise((resolve) => {
            const config = {
                cupomFiscal: cupomFiscal,
                dataFiscal: dataFiscal,
                horaFiscal: horaFiscal,
                trnAdditionalParameters: ``,
                handleTermina: (status, data, message) => {
                    resolve({
                        status, data: organizaTransacoesPendentes(data), message
                    })
                },
                hasCallFinishTransaction: false,
                confirmaDeterminado: confirma
            }
            servico.startTransation(130, '', config)
        })
    }

    function getTransacaoPendenteIndividual({valor, cupomFiscal, dataFiscal, horaFiscal, confirma}) {
        return new Promise((resolve) => {
            const config = {
                cupomFiscal: cupomFiscal,
                dataFiscal: dataFiscal,
                horaFiscal: horaFiscal,
                trnAdditionalParameters: ``,
                handleTermina: (status, data, message) => {
                    resolve({
                        status, data: organizaTransacoesPendentes(data), message
                    })
                },
                hasCallFinishTransaction: true,
                confirmaDeterminado: confirma
            }
            servico.startTransation(131, valor, config)
        })
    }

    function continueTransaction(dataInput) {
        servico.continueTransaction(dataInput)
    }

    function continueTransaction2(status, dataInput, tipoCampo) {
        servico.continueTransaction(dataInput, tipoCampo, status);
    }

    function solicitarCancelamentoTransacaoAtual() {
        return servico.solicitarCancelamentoTransacaoAtual()
    }

    function finishTransaction({confirma, cupomFiscal, dataFiscal, horaFiscal, trnAdditionalParameters}) {
        return new Promise((resolve) => {
            const config = {
                taxInvoiceNumber: cupomFiscal,
                taxInvoiceDate: dataFiscal,
                taxInvoiceTime: horaFiscal,
                handleTermina: (status, data, message) => {
                    resolve({
                        status, data, message
                    })
                },
            }
            servico.finishTransaction(confirma, config, trnAdditionalParameters ? trnAdditionalParameters : '')
        })
    }

    function setManipuladores(manipuladoresInput) {
        servico.setManipuladores(manipuladoresInput)
    }

    function setCpf(cpf2) {
        cpf = cpf2
    }

    function ultimoCupom({cupomFiscal, dataFiscal, horaFiscal}) {
        return new Promise((resolve) => {
            const config = {
                cupomFiscal: cupomFiscal,
                dataFiscal: dataFiscal,
                horaFiscal: horaFiscal,
                trnAdditionalParameters: ``,
                handleTermina: (status, data, message) => {
                    resolve({
                        status, data: organizaDadosTefReimpressao(data), message
                    })
                },
                hasCallFinishTransaction: true
            }
            servico.startTransation(114, '', config)
        })
    }

    function cupomEspecifico({cupomFiscal, dataFiscal, horaFiscal}) {
        return new Promise((resolve) => {
            const config = {
                cupomFiscal: cupomFiscal,
                dataFiscal: dataFiscal,
                horaFiscal: horaFiscal,
                trnAdditionalParameters: ``,
                handleTermina: (status, data, message) => {
                    resolve({
                        status, data: organizaDadosTefReimpressao(data), message
                    })
                },
                hasCallFinishTransaction: true
            }
            servico.startTransation(113, '', config)
        })
    }

    function cancelarTransacaoTef({cupomFiscal, dataFiscal, horaFiscal}) {
        return new Promise((resolve) => {
            const config = {
                cupomFiscal: cupomFiscal,
                dataFiscal: dataFiscal,
                horaFiscal: horaFiscal,
                trnAdditionalParameters: `{TransacoesAdicionaisHabilitadas=8}`,
                handleTermina: (status, data, message) => {
                    resolve({
                        status, data: organizaDadosTefReimpressao(data), message
                    })
                },
                hasCallFinishTransaction: true
            }
            servico.startTransation(200, '', config)
        })
    }

    function cancelarCredito({cupomFiscal, dataFiscal, horaFiscal}) {
        return new Promise((resolve) => {
            const config = {
                cupomFiscal: cupomFiscal,
                dataFiscal: dataFiscal,
                horaFiscal: horaFiscal,
                trnAdditionalParameters: ``,
                handleTermina: (status, data, message) => {
                    resolve({
                        status, data: organizaDadosTefReimpressao(data), message
                    })
                },
                hasCallFinishTransaction: true
            }
            servico.startTransation(210, '', config)
        })
    }

    function cancelarDebito({cupomFiscal, dataFiscal, horaFiscal}) {
        return new Promise((resolve) => {
            const config = {
                cupomFiscal: cupomFiscal,
                dataFiscal: dataFiscal,
                horaFiscal: horaFiscal,
                trnAdditionalParameters: ``,
                handleTermina: (status, data, message) => {
                    resolve({
                        status, data: organizaDadosTefReimpressao(data), message
                    })
                },
                hasCallFinishTransaction: true
            }
            servico.startTransation(211, '', config)
        })
    }

    function cancelarPix({cupomFiscal, dataFiscal, horaFiscal}) {
        return new Promise((resolve) => {
            const config = {
                cupomFiscal: cupomFiscal,
                dataFiscal: dataFiscal,
                horaFiscal: horaFiscal,
                trnAdditionalParameters: `{TransacoesAdicionaisHabilitadas=8}`,
                handleTermina: (status, data, message) => {
                    resolve({
                        status, data: organizaDadosTefReimpressao(data), message
                    })
                },
                hasCallFinishTransaction: true
            }
            servico.startTransation(123, '', config)
        })
    }

    function menuAdministrativo({cupomFiscal, dataFiscal, horaFiscal}) {
        return new Promise((resolve) => {
            const config = {
                cupomFiscal: cupomFiscal,
                dataFiscal: dataFiscal,
                horaFiscal: horaFiscal,
                trnAdditionalParameters: `{TransacoesAdicionaisHabilitadas=4178}`,
                handleTermina: (status, data, message) => {
                    resolve({
                        status, data: data, message
                    })
                },
                hasCallFinishTransaction: true
            }
            servico.startTransation(110, '', config)
        })
    }

    return {
        transacaoCredito,
        transacaoDebito,
        transacaoPix,
        getTransacoesPendentes,
        continueTransaction,
        continueTransaction2,
        finishTransaction,
        setManipuladores,
        transacaoParceladoEstabelecimento,
        transacaoParceladoAdministradora,
        getTransacaoPendenteIndividual,
        setCpf,
        ultimoCupom,
        cupomEspecifico,
        cancelarTransacaoTef,
        cancelarCredito,
        cancelarDebito,
        cancelarPix,
        menuAdministrativo,
        solicitarCancelamentoTransacaoAtual,
        getState,
        getStatePinPad,
        getSession,
        createSession,
        deleteSession,
        verificaEstadoInicial,
        getSessionId
    }
}

export default getInterfaceSitef
